export const scheduling = {
  // ── 학습자 일정 페이지 (schedule/page.tsx) ──
  // 헤더
  title: '레슨 희망 일시 보내기',
  back: '마이페이지로 돌아가기',
  timezoneLabel: '시간대',
  timezoneHint: '(본인의 현지 시간으로 입력해 주세요)',

  // 자가 신청 폼 (student_driven / 개인)
  choiceLabel: '{{n}}순위 희망',
  required: '필수',
  optional: '선택',
  dateLabel: '날짜',
  timeLabel: '시간',
  timePlaceholder: '선택',
  submit: '희망 일시 보내기',
  submitting: '전송 중...',
  formNote: '전송 후 운영이 상대방과 일정을 조정합니다. 확정되면 이메일로 안내드립니다.',

  // 유효성 검사
  errorFirstRequired: '1순위 희망의 날짜와 시간은 필수입니다',
  errorPairBoth: '{{n}}순위 희망은 날짜와 시간을 모두 입력해 주세요',
  errorCreateFailed: '요청 생성에 실패했습니다',

  // 완료
  doneTitle: '전송 완료!',
  doneMessage: '희망 일시를 접수했습니다.\n운영이 확인하는 대로 Google Meet 링크를 이메일로 보내드립니다.',
  toMyPage: '마이페이지로',

  // 로딩
  loading: '로딩 중...',

  // ── manager_driven 표시 (단체가 일정 조정) ──
  managerDrivenTitle: '일정은 단체가 조정합니다',
  managerDrivenMessage: '소속 단체의 관리자가 일정을 조정합니다. 확정되면 이메일로 안내드리니 잠시만 기다려 주세요.',
  managerDrivenNote: '문의 사항이 있으시면 소속 단체 관리자에게 문의해 주세요.',

  // ── 단체 매니저 뷰 (org/schedule/page.tsx) ──
  orgTitle: '소속 멤버의 희망 일시',
  orgSubtitle: '단체 멤버가 보낸 레슨 희망 일시 목록입니다.',
  orgBack: '마이페이지로 돌아가기',
  orgMemberLabel: '멤버',
  orgSlotsLabel: '희망 일시',
  orgStatusLabel: '상태',
  orgChoice: '{{n}}순위 희망',
  orgEmpty: '현재 표시할 수 있는 희망 일시가 없습니다.',
  orgNoAccessTitle: '희망 일시를 가져올 수 없습니다',
  orgNoAccessMessage: '권한 설정으로 인해 멤버의 희망 일시를 직접 가져올 수 없는 경우가 있습니다. 일정 확정은 관리자(admin)에게 요청해 주세요.',
  orgLoadError: '불러오기에 실패했습니다. 잠시 후 다시 시도해 주세요.',
  retry: '다시 불러오기',

  // 상태 표시
  statusPending: '조정 대기',
  statusConfirmed: '확정됨',
  statusOther: '기타',
};
